import { render } from "./OfferInfo.vue?vue&type=template&id=c8a58d44&scoped=true"
import script from "./OfferInfo.vue?vue&type=script&lang=js"
export * from "./OfferInfo.vue?vue&type=script&lang=js"

import "./OfferInfo.vue?vue&type=style&index=0&id=c8a58d44&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8a58d44"]])

export default __exports__